
import { lazy } from 'react';



const ViewSingleInvoiceConfig = {
  settings: {
    layout: {
        style : 'layout1',
        config: {
          
            navbar : {
                display : false,
                
            },
            toolbar: {
                display : false,
            },
            footer : {
                display : false,
                
            },
            mode   : 'fullwidth'
        }
    },
    
},
  routes: [
    {
      path: '/viewinvoice',
      component: lazy(() => import('./ViewSingleInvoice')),
    },
  ],
};

export default ViewSingleInvoiceConfig





